import { Link } from 'react-router-dom';
import { articles, articleSlugs } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-medium mb-4">
            SEO Guides
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Superbuy Sheet Guides & Resources
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Dive deeper with our in-depth guides covering everything from beginner tutorials to advanced shopping strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {articleSlugs.map((slug) => {
            const article = articles[slug];
            if (!article) return null;
            return (
              <Link
                key={slug}
                to={`/article/${slug}`}
                className="group flex flex-col bg-background-50 border border-background-200/60 rounded-2xl overflow-hidden hover:border-primary-300 transition-all cursor-pointer"
              >
                <div className="h-36 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.imageAlt}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 flex flex-col flex-1">
                  <span className="text-xs text-primary-600 font-medium mb-1">{article.badge}</span>
                  <h3 className="text-sm font-semibold text-foreground-900 leading-tight mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title.split(':')[0] || article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-auto">{article.readingTime}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}